import {Big} from 'big.js';
import {isBlank} from "./string-utils";

export function bigToString(bigNumber: Big, fractionDigits: number = 40): string {
    if(bigNumber == null) {
        return  new Big("0").toFixed(fractionDigits);
    }
    return bigNumber.toFixed(fractionDigits);
}

export function parseBig(str: string): Big {
    if (isBlank(str)) {
        return new Big("0");
    }
    return new Big(str);
}

export class MathUtils {

    static toString(bigNumber: Big): string {
        const fractionDigits = 3
        if (bigNumber == null) {
            return new Big("0").toFixed(fractionDigits);
        }
        return bigNumber.toFixed(fractionDigits);
    }

    static round(bigNumber: Big, decimal: number): number {
        if (bigNumber == null) {
            return 0;
        }
        return Number(bigNumber.toFixed(decimal));
    }

    static bigIsNullOrZero(big: Big): boolean {
        return big == null || parseFloat(big.toFixed(3)) === 0;
    }

    static bigIsBelowZero(big: Big): boolean {
        return big != null && parseFloat(big.toFixed(3)) < 0;
    }

    static bigIsInteger(big: Big): boolean {
        return big != null && parseFloat(big.toString()) === parseInt(big.toString(), 10);
    }

    static maxArrayBig(bigs : Big[]){
        let max = bigs[0];
        for (let i = 1; i < bigs.length; i++) {
            if(bigs[i].gt(max)) {
                max = bigs[i];
            }
        }
        return max;
    }

    static maxBig(big1: Big, big2: Big): Big{
        let max = new Big(big2);
        if(big1.gt(big2)) {
            max = big1;
        }
        return max;
    }
}

